export default $axios => ({ store }) => ({
    async download(url) {
        return $axios.get(url, { responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data],));
                let fileName = response.headers['content-disposition'].match(/filename="(.*?)"/i)[1];
                let link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${fileName}`);
                link.click();
            });
    },
});
